import * as Sentry from '@sentry/browser';

import {
  InputPreprocessors,
  PiqPreprocessorParameters,
  PreprocessorParam,
} from '@cashier/cashier-model';

const appendEncrypter = (id: string, src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const encrypterScript = document.getElementById(id);

    if (!encrypterScript && src) {
      const script = document.createElement('script');
      script.id = id;
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;

      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${id}`));

      document.body.appendChild(script);
    } else if (encrypterScript) {
      resolve();
    } else {
      reject(new Error(`Failed to load script: ${id}`));
    }
  });
};

const getPiqEncrypterUrl = (parameters: PiqPreprocessorParameters): string => {
  if (parameters?.preprocessorUrl) {
    return parameters?.preprocessorUrl;
  }

  // BC for internal PIQ integration
  if (parameters?.paymentIqMerchantId) {
    return `${(window as any).paymentIqCardEncrypterUrl}/${parameters.paymentIqMerchantId}`;
  }

  Sentry.captureException(
    new Error(
      '####PaymentIq encryptor url not found: paymentIqMerchantId is missing####',
    ),
    { extra: { parameters } },
  );

  return '';
};

export const loadPreprocessorResources = (
  preprocessor: PreprocessorParam,
): Promise<void> => {
  switch (preprocessor.type) {
    case InputPreprocessors.ORCHID_ENCRYPTOR:
      return appendEncrypter(
        'orchidScript',
        preprocessor.parameters.preprocessorUrl,
      );
    case InputPreprocessors.PIQ_ENCRYPTOR:
      return appendEncrypter(
        'paymentIqScript',
        getPiqEncrypterUrl(
          preprocessor.parameters as PiqPreprocessorParameters,
        ),
      );
    default:
      return Promise.resolve();
  }
};
